import { dew as _isHexDew } from "../data/isHex.js";
import { dew as _fromHexDew } from "../encoding/fromHex.js";
import { dew as _toHexDew } from "../encoding/toHex.js";
import * as _secp256k2 from "@noble/curves/secp256k1";
var _secp256k = _secp256k2;
try {
  if ("default" in _secp256k2) _secp256k = _secp256k2.default;
} catch (e) {}
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.recoverPublicKey = void 0;
  const isHex_js_1 = _isHexDew();
  const fromHex_js_1 = _fromHexDew();
  const toHex_js_1 = _toHexDew();
  async function recoverPublicKey({
    hash,
    signature
  }) {
    const signatureHex = (0, isHex_js_1.isHex)(signature) ? signature : (0, toHex_js_1.toHex)(signature);
    const hashHex = (0, isHex_js_1.isHex)(hash) ? hash : (0, toHex_js_1.toHex)(hash);
    let v = (0, fromHex_js_1.hexToNumber)(`0x${signatureHex.slice(130)}`);
    if (v === 0 || v === 1) v += 27;
    const {
      secp256k1
    } = await Promise.resolve().then(() => _secp256k);
    const publicKey = secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(v - 27).recoverPublicKey(hashHex.substring(2)).toHex(false);
    return `0x${publicKey}`;
  }
  exports.recoverPublicKey = recoverPublicKey;
  //# sourceMappingURL=recoverPublicKey.js.map
  return exports;
}